
import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import mediaQueries from "../constants/mediaQueries";
import breakpoints from "../constants/breakpoints";

const imagelink = process.env.PUBLIC_URL + '/images/focus_areas/entretenimento.png';

const imageLinks = [
  {name: "componentes_" ,image:process.env.PUBLIC_URL + '/images/focus_areas/componentes.png', description: 'Produção de componentes de madeira e plástico.'},
  {name: "revestimentos_" ,image:process.env.PUBLIC_URL + '/images/focus_areas/revestimentos.png', description: 'Revestimentos em madeira e plástico com relevos e furações.'},
  {name: "produtos_" , image: process.env.PUBLIC_URL + '/images/focus_areas/produtos.png', description: 'Produtos decorativos e/ou  funcionais.'}
];

const MainContainer = styled.div`
  width: 100%;
  
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  user-select: none;
  cursor: pointer;

  background: rgb(230,230,230);

  @media ${mediaQueries.extraSmallDevices} {
    height: auto;
    padding-left: 5vh;
    padding-right: 0;
    padding-bottom: 5vh;
    margin-top: 5px;
  }
  @media ${mediaQueries.smallDevices} {
    height: auto;
    padding-left: 5vh;
    padding-right: 0;
    padding-bottom: 5vh;
    margin-top: 5px;
  }
  @media ${mediaQueries.mediumDevices} {
    height: auto;
    padding-left: 10vh;
    padding-right: 0;
    padding-bottom: 5vh;
    margin-top: 5px;
    margin-bottom: 50px;
  }
  @media ${mediaQueries.largeDevices} {
    height: 400px;
    padding-left: 15vh;
    padding-right: 15vh;
    padding-bottom: 0;
    margin-top: 20px;
    margin-bottom: 0px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    height: 400px;
    padding-left: 15vh;
    padding-right: 15vh;
    padding-bottom: 0;
    margin-top: 20px;
    margin-bottom: 0px;
  }
`;

const Title = styled.div`

  color: black;

  font-family: "SUSE", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 30px;

  margin-top: 50px;

  @media ${mediaQueries.extraSmallDevices} {
    font-size: 25px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 25px;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 25px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 30px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 30px;
  }

`;

const AreasContainer = styled.div`
  width: 100%;
  
  display: flex;
  align-content: center;
  align-items: flex-start;
  justify-content: space-between;



  @media ${mediaQueries.extraSmallDevices} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 50px;
    padding-left: 0px;
    padding-right: 0px;
  }
  @media ${mediaQueries.smallDevices} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }
  @media ${mediaQueries.mediumDevices} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10px;
    padding-left: 0px;
    padding-right: 0px;
  }
  @media ${mediaQueries.largeDevices} {
    flex-direction: row;
    align-items: center;
    margin-top: 50px;
    padding-left: 50px;
    padding-right: 50px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    flex-direction: row;
    align-items: center;
    margin-top: 50px;
    padding-left: 50px;
    padding-right: 50px;
  }



`;

const AreaBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;

  @media ${mediaQueries.extraSmallDevices} {
    width: 100%;
    padding: 5vh;
    margin-left: 0;
  }
  @media ${mediaQueries.smallDevices} {
    width: 100%;
    padding: 5vh;
    margin-left: 0;
  }
  @media ${mediaQueries.mediumDevices} {
    width: 70%;
    padding: 5vh;
    margin-left: 10vh;
  }
  @media ${mediaQueries.largeDevices} {
    width: 30%;
    padding: 0;
    margin-left: 0;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    width: 30%;
    padding: 0;
    margin-left: 0;
  }



`;

const AreaTitle = styled.div`
  margin-bottom: 20px;

  color: black;

  font-family: "SUSE", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 25px;

  @media ${mediaQueries.extraSmallDevices} {
    font-size: 20px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 20px;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 21px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 25px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 25px;
  }
 
`;

const IconDescriptionContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  margin-top: 10px;

  @media ${mediaQueries.extraSmallDevices} {
    padding: 1vh;
    align-items: center;
  }
  @media ${mediaQueries.smallDevices} {
    padding: 1vh;
    align-items: center;
  }
  @media ${mediaQueries.mediumDevices} {
    padding: 1vh;
    align-items: center;

  }
  @media ${mediaQueries.largeDevices} {
    padding: 0;
    align-items: flex-start;

  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    padding: 0;
    align-items: flex-start;

  }
  
`;

const Description = styled.div`
  width: 100%;

  color: black;
  
  /* font-family: "Libre Franklin", sans-serif;
  ;
  font-style: normal;
  font-size: 20px; */

  font-family: "Kanit", sans-serif;
  font-weight: 200;
  font-style: normal;
  font-size: 20px;

  @media ${mediaQueries.extraSmallDevices} {
    font-size: 16px;
    margin-left: 5vh;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 18px;
    margin-left: 5vh;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 18px;
    margin-left: 5vh;

  }
  @media ${mediaQueries.largeDevices} {
    font-size: 20px;
    margin-left: 4vh;

  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 20px;
    margin-left: 4vh;

  }
 
`;


class FocusAreas extends React.Component {
  componentDidMount() {}

  renderAreas = () => imageLinks.map( (data, i) => 
    <AreaBlock key={i}>
      <AreaTitle>{data.name}</AreaTitle>
      <IconDescriptionContainer>
        <img width={"20%"} src={data.image} />
        <Description>{data.description}</Description>
      </IconDescriptionContainer>
    </AreaBlock>
  ) ;

  render(){
    return(
      <MainContainer>
        <Title>As nossas áreas de atuação_</Title>
        <AreasContainer>
          {this.renderAreas()}
        </AreasContainer>
      </MainContainer>
    );
    ;

  }
}


export default FocusAreas;